import { render } from "./RegistroPagos.vue?vue&type=template&id=27376012&scoped=true"
import script from "./RegistroPagos.vue?vue&type=script&lang=js"
export * from "./RegistroPagos.vue?vue&type=script&lang=js"

import "./RegistroPagos.vue?vue&type=style&index=0&id=27376012&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27376012"]])

export default __exports__